import React from 'react'
import IconsAuraExp12 from './Images/IconsAuraExp12.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleChevronRight} from '@fortawesome/free-solid-svg-icons';



function ExpCard12() {
  return (

    <div className='ExpPgCard  '>
      
        <p className='ExpPgHExpName'> Metal Work workshop </p>
        

        <p className='ExpPgHCat'> Craft </p>
        <p className='ExpPgHCode'> AURAMUSE112 </p>

        

        <div className='IconsAuraExpDiv'>  <img className='IconsAuraExp' src={IconsAuraExp12} /> </div>

        <FontAwesomeIcon className='FaIconCirc' icon={faCircleChevronRight} size="xl" style={{color: " ", }} />
        

    </div>




    
  )
}

export default ExpCard12